import { render, staticRenderFns } from "./FeatureTable.vue?vue&type=template&id=4cad2532&scoped=true&"
import script from "./FeatureTable.vue?vue&type=script&lang=js&"
export * from "./FeatureTable.vue?vue&type=script&lang=js&"
import style0 from "./FeatureTable.vue?vue&type=style&index=0&id=4cad2532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cad2532",
  null
  
)

export default component.exports